// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  caps0: __t.u32(),
  caps1: __t.u32(),
  skirm0: __t.u32(),
  skirm1: __t.u32(),
  fri0: __t.u32(),
  cor0: __t.u32(),
  fri1: __t.u32(),
  cor1: __t.u32(),
  ageS: __t.u32(),
  targetSystem: __t.string(),
};
